// extracted by mini-css-extract-plugin
export var divider = "_41-0";
export var dividerText = "_41-1";